"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var inversify_react_1 = require("inversify-react");
var styles = __importStar(require("./ColourPalette.css"));
var classnames_1 = __importDefault(require("classnames"));
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var colord_1 = require("colord");
var Types_1 = require("DataStores/Account/Types");
var Goldilocks_1 = __importDefault(require("@qwilr/pages-common/src/Goldilocks"));
var react_colorful_1 = require("react-colorful");
var ColorInputError;
(function (ColorInputError) {
    ColorInputError["IncorrectHex"] = "Looks like this hex code isn\u2019t right. Please try again.";
})(ColorInputError || (ColorInputError = {}));
var userInputAsSanitizedColor = function (rawValue) {
    var value = rawValue;
    var format = (0, colord_1.getFormat)(value);
    if (!format) {
        value = "#".concat(value);
        format = (0, colord_1.getFormat)(value);
    }
    if (!format) {
        return null;
    }
    if (format === "hex" && value.length !== 4 && value.length !== 7) {
        return null;
    }
    var color = (0, colord_1.colord)(value);
    if (!color.isValid()) {
        return null;
    }
    if (color.alpha() !== 1) {
        return null;
    }
    return color;
};
var convertSelectedColor = function (selectedColor) {
    if (!selectedColor) {
        return null;
    }
    if (selectedColor.value && (0, colord_1.colord)(selectedColor.value).isValid()) {
        return (0, colord_1.colord)(selectedColor.value).alpha(1);
    }
    return null;
};
var ColorPalette = (0, mobx_react_1.observer)(function (_a) {
    var _b, _c, _d;
    var _e, _f;
    var presetColors = _a.presetColors, onColorChange = _a.onColorChange, _g = _a.theme, theme = _g === void 0 ? "dark" : _g, rawSelectedColor = _a.selectedColor, includeColorPanelPicker = _a.includeColorPanelPicker, type = _a.type;
    var stylePermissionStore = (0, inversify_react_1.useInjection)("stylePermissionStore");
    var hasCustomColorPermission = type === "brand" ||
        stylePermissionStore.allowStyle({
            block: Types_1.StyleAccessType.BlockCustomColors,
            content: Types_1.StyleAccessType.ContentCustomColors,
        }[type]);
    var showColorInput = hasCustomColorPermission;
    var _h = __read(react_1.default.useState(), 2), errorMessage = _h[0], setErrorMessage = _h[1];
    var _j = __read(react_1.default.useState(), 2), internalValue = _j[0], setInternalValue = _j[1];
    var eyeDropper = window.EyeDropper ? new window.EyeDropper() : null;
    var selectedColor = convertSelectedColor(rawSelectedColor);
    var handlePaletteClick = function (color) {
        onColorChange(color);
        setInternalValue(undefined);
    };
    var handleColorInputChange = function (value) {
        var color = userInputAsSanitizedColor(value);
        if (color) {
            onColorChange({
                value: color.toHex(),
                themeIndex: null,
            });
        }
        setInternalValue(value);
    };
    var handleColorInputBlur = function () {
        if (internalValue === undefined) {
            return;
        }
        var color = userInputAsSanitizedColor(internalValue);
        if (!color) {
            setErrorMessage(ColorInputError.IncorrectHex);
        }
        else {
            setInternalValue(undefined);
        }
    };
    var handleEyeDropperClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var color, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, eyeDropper.open()];
                case 1:
                    color = _b.sent();
                    onColorChange({
                        value: color.sRGBHex,
                        themeIndex: null,
                    });
                    setInternalValue(undefined);
                    return [3, 3];
                case 2:
                    _a = _b.sent();
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var color = userInputAsSanitizedColor(internalValue);
        if (internalValue === undefined || color) {
            setErrorMessage(undefined);
        }
    }, [internalValue]);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m" },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: (0, classnames_1.default)(styles.container, (_b = {}, _b[tokens_1.darkTheme] = theme === "dark", _b)), direction: "horizontal", align: "start", gap: "xxs", wrap: true }, presetColors.map(function (color, index) {
            var _a, _b;
            return (react_1.default.createElement(kaleidoscope_1.IconButton, { size: kaleidoscope_1.ButtonSize.Medium, isRound: true, key: "".concat(color.value, "-").concat(index), type: kaleidoscope_1.ButtonType.Secondary, onClick: function () { return handlePaletteClick(color); }, className: styles.colorButton(), style: (0, dynamic_1.assignInlineVars)((_a = {},
                    _a[styles.buttonColor] = color.value,
                    _a)), icon: (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.isEqual((0, colord_1.colord)(color.value))) ? (react_1.default.createElement(icons_1.Tick, { className: styles.icon, style: (0, dynamic_1.assignInlineVars)((_b = {}, _b[styles.iconColor] = (0, Goldilocks_1.default)(color.value, { mode: "text" }), _b)) })) : (react_1.default.createElement(react_1.default.Fragment, null)) }));
        })),
        showColorInput && includeColorPanelPicker && (react_1.default.createElement("div", { className: styles.colorPanelPicker },
            react_1.default.createElement(react_colorful_1.HexColorPicker, { color: selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.toHex().toUpperCase(), onChange: handleColorInputChange }))),
        showColorInput && (react_1.default.createElement("div", { onBlur: handleColorInputBlur },
            react_1.default.createElement(kaleidoscope_1.Stack, null,
                react_1.default.createElement(kaleidoscope_1.TextInput, { placeholder: "#FFFFFF", error: errorMessage, theme: theme === "dark" ? kaleidoscope_1.TextInputTheme.Dark : kaleidoscope_1.TextInputTheme.Light, size: kaleidoscope_1.TextInputSize.Medium, className: styles.colorInput, startElement: react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.circle({
                            show: internalValue !== undefined ? !!userInputAsSanitizedColor(internalValue) : !!selectedColor,
                        }), (_c = {},
                            _c[tokens_1.darkTheme] = theme === "dark",
                            _c)), style: (0, dynamic_1.assignInlineVars)((_d = {},
                            _d[styles.circleColor] = internalValue !== undefined
                                ? (_e = userInputAsSanitizedColor(internalValue)) === null || _e === void 0 ? void 0 : _e.toHex()
                                : selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.toHex(),
                            _d)) }), endElement: eyeDropper ? (react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.EyeDropper, null), onClick: handleEyeDropperClick, buttonState: kaleidoscope_1.ButtonState.Idle, size: kaleidoscope_1.ButtonSize.Small })) : undefined, label: "Custom colour", labelHidden: true, onChange: handleColorInputChange, value: (_f = internalValue !== null && internalValue !== void 0 ? internalValue : selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.toHex().toUpperCase()) !== null && _f !== void 0 ? _f : "" }))))));
});
exports.default = ColorPalette;
